import { cn } from '@shadcn/lib/utils';
import { User } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Logo } from '../../atoms/logo/logo';
import { UrgentHelpButton } from '../../molecules/urgent-help-button';

type AppBarProps = {
  readonly className?: string;
  readonly 'aria-label'?: string;
  readonly iconHref?: string;
  readonly logoHref?: string;
  readonly hideIcon?: boolean;
  readonly showUrgentHelpDialog: boolean;
  readonly onShowUrgentHelpDialogChange: (open: boolean) => void;
};

function PatientAppBar({
  className,
  'aria-label': ariaLabel,
  iconHref,
  logoHref,
  hideIcon,
  showUrgentHelpDialog,
  onShowUrgentHelpDialogChange,
}: AppBarProps) {
  const { t } = useTranslation();

  const logo = <Logo className="h-4" size="sm" />;
  const logoElement = logoHref ? <Link to={logoHref}>{logo}</Link> : logo;
  const accountIcon = <User aria-label="Account icon" color="var(--color-abyssyl-blue-light)" />;
  const accountIconElement = iconHref ? <Link to={iconHref}>{accountIcon}</Link> : accountIcon;

  return (
    <header
      aria-label={ariaLabel ?? t('navigation.main')}
      className={cn('z-1 py-3 bg-background shadow-md relative', className)}
    >
      <div className="container flex items-center justify-between">
        <div className="flex justify-start">{logoElement}</div>
        <div className="flex justify-end gap-4 items-center">
          <UrgentHelpButton onOpenChange={onShowUrgentHelpDialogChange} open={showUrgentHelpDialog} />
          {!hideIcon && accountIconElement}
        </div>
      </div>
    </header>
  );
}

PatientAppBar.displayName = 'PatientAppBar';

export { PatientAppBar };
